import React, { useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { convertFromMarkdown } from "./MarkdownConverterPlugin";

interface CustomOnChangePluginProps {
  value: string;
}

export function LexicalDefaultValueOnChangePlugin({ value }: CustomOnChangePluginProps) {
  const [editor] = useLexicalComposerContext();
  const [isFirstRender, setIsFirstRender] = useState(true);

  React.useEffect(() => {
    if (!value || !isFirstRender) return;
    setIsFirstRender(false);

    editor.update(() => convertFromMarkdown(value));
  }, [editor, value, isFirstRender]);

  React.useEffect(() => {
    setIsFirstRender(true);
  }, [value]);

  return null;
}
